import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Flex,
  FlexItem,
  Grid,
  GridItem,
  Stack,
  StackItem,
  TextContent,
} from '@patternfly/react-core';
import { ArrowRightIcon } from '@patternfly/react-icons';
import './StatusErrorPage.scss';
import React from 'react';
import Env from 'utils/env';

interface ErrorPageProps {
  errorStatus?: Number;
}

const StatusErrorPage: React.FC<ErrorPageProps> = (props: ErrorPageProps) => {
  const { errorStatus = 404 } = props;
  const GotoLinks = (e) => {
    const value = e.target.innerText;
    if (value === 'Reload this page' || value === "Refresh this Page") {
      window.location.reload();
    } else if (value === 'Check our system status') {
      window.open('https://status.redhat.com');
    } else if (value === 'Partner Connect Homepage ') {
      window.open(`${Env.ConnectPortalUrls[Env.getEnvName()]}`);
    }
  };

  return (
    <Flex direction={{ default: 'column' }} className="error-page-container">
      <FlexItem className="upper-page-section">
        <TextContent className="upper-page-section__text-content">
          <p className="upper-page-section__first-text-content">
            {' '}
            WE&apos;RE ALWAYS OPEN AND HONEST
          </p>
          <p className="upper-page-section__second-text-content">
            {' '}
            {errorStatus} Its true, we&apos;ve lost this page
          </p>
        </TextContent>
      </FlexItem>
      <FlexItem className="lower-page-section">
        <Grid
          md={12}
          lg={6}
          hasGutter
          span={12}
          className="lower-page-section__main-grid">
          <GridItem span={6}>
            <Card className="dashboard-card">
              <CardTitle className="dashboard-card__title">
                What you can do
              </CardTitle>
              <CardBody>
                <Stack hasGutter>
                  <StackItem>
                    This maybe a temporary issue. Try refreshing the page
                  </StackItem>
                  <StackItem isFilled>
                    <Button
                      component="a"
                      onClick={(e) => GotoLinks(e)}
                    >
                      Refresh this Page
                    </Button>
                  </StackItem>
                  <StackItem>
                    If the issue persists, contact Support for more help.
                  </StackItem>
                  <StackItem isFilled>
                    <Button
                      variant="secondary"
                      component="a"
                      href={`${Env.ConnectPortalUrls[Env.getEnvName()]
                        }support/technology-partner/#/`}
                        target="_blank">
                      Contact support
                    </Button>
                  </StackItem>
                </Stack>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem span={6}>
            <Card className="dashboard-card-secondary">
              <CardTitle className="dashboard-card__title">
                Some places to go from here
              </CardTitle>
              <CardBody>
                {' '}
                <Stack hasGutter>
                  <StackItem>
                    <Button
                      variant="link"
                      icon={<ArrowRightIcon />}
                      iconPosition="right"
                      onClick={(e) => GotoLinks(e)}>
                      Check our system status
                    </Button>{' '}
                  </StackItem>
                  <StackItem>
                    <Button
                      variant="link"
                      icon={<ArrowRightIcon />}
                      iconPosition="right"
                      onClick={(e) => GotoLinks(e)}>
                      Partner Connect Homepage{' '}
                    </Button>{' '}
                  </StackItem>
                </Stack>
              </CardBody>
            </Card>
          </GridItem>
        </Grid>
      </FlexItem>
    </Flex>
  );
};

export default StatusErrorPage;
